<script setup lang="ts">
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock-upgrade";
import { ZaprooFormControlSizes } from "@zaprooecommerce/storefront-ui-vue";

const props = withDefaults(
  defineProps<{
    disableScroll?: boolean;
    size?: ZaprooFormControlSizes;
  }>(),
  {
    size: ZaprooFormControlSizes.base,
  },
);

const listHtmlElement = shallowRef<HTMLElement>();

onMounted(() => {
  if (props.disableScroll && listHtmlElement.value) {
    disableBodyScroll(listHtmlElement.value, { reserveScrollBarGap: true });
  }
});

onBeforeUnmount(() => {
  if (props.disableScroll && listHtmlElement.value) {
    enableBodyScroll(listHtmlElement.value);
  }
});
</script>

<template>
  <ul ref="listHtmlElement" class="list" :class="[`size-${size}`]">
    <slot />
  </ul>
</template>

<style lang="scss">
ul.list {
  @apply max-h-[100%] overflow-auto;

  li {
    * {
      transition:
        0.1s ease color,
        0.1s ease background-color;
    }

    & > * {
      @apply flex h-full w-full cursor-pointer items-center justify-between font-semibold;

      span.content {
        @apply flex-1 text-left;
      }
    }

    &:hover,
    &.active {
      & > * {
        @apply bg-secondary-50 text-primary-700 active:bg-secondary-100;
      }
    }
  }

  &.size-base {
    & > li {
      @apply min-h-14;

      & > * {
        @apply min-h-[48px] px-2 py-2 pr-4 font-semibold;

        .before {
          @apply mr-3;
        }

        .after {
          @apply ml-3;
        }
      }
    }
  }
}
</style>
